<template>
    <b-card class="shadow">
        <div class="row">
            <div class="col-12">
                <div
                    class="d-flex align-items-center justify-content-between mb-4"
                >
                    <h5 class="mb-0 text-gray-800">
                        {{ $t("Acolhimentos em geral") }}
                    </h5>
                    <b-button-group>
                        <b-button
                            variant="outline-dark"
                            :class="viewFilterReport === true ? 'active' : ''"
                            @click="viewFilters"
                        >
                            <i class="fas fa-filter"></i>
                            {{ $t("Filtros") }}
                        </b-button>
                        <b-button variant="outline-dark" @click="print()">
                            <i class="fas fa-print"></i>
                        </b-button>
                        <b-button
                            variant="outline-dark"
                            @click="exportar()"
                            :title="$t('Exportar')"
                            v-b-tooltip.hover
                        >
                            <i class="fas fa-file-excel"></i>
                        </b-button>
                    </b-button-group>
                </div>
            </div>

            <div class="col-12" v-if="viewFilterReport">
                <!-- Filtros -->
                <form @submit.prevent="getAnalytics" ref="addItem">
                    <div class="row">
                        <div class="col-md-6">
                            <label><b>Pesquisar</b></label>
                            <div class="input-group">
                                <b-input
                                    placeholder="Protocolo ou usuário"
                                    class="form-control search-input"
                                    type="text"
                                    v-model="search"
                                    aria-describedby="input-search"
                                    @keydown.enter.prevent="getAnalytics"
                                />
                            </div>
                            <p class="small text-muted">
                                No campo acima você pode pesquisar por:
                                Protocolo ou usuário.
                            </p>
                        </div>

                        <form-calendar
                            v-model="data_inicio"
                            grid="3"
                            label="Data inicial"
                        />

                        <form-calendar
                            v-model="data_fim"
                            grid="3"
                            label="Data final"
                            :required="verificaDataInicial"
                            :min-date="data_inicio"
                        />

                        <form-select
                            v-model="filtroMotivo"
                            grid="6"
                            label="Motivo(s) do acolhimento"
                            :itens="motivosAcolhimentoGeral"
                            multiple
                        />

                        <form-select
                            v-model="filtroStatus"
                            grid="6"
                            label="Status"
                            :itens="status"
                            :loading="loadingStatus"
                            :disabled="loadingStatus"
                            multiple
                        />

                        <form-select
                            v-model="filtroUnidades"
                            label="Unidade(s)"
                            grid="6"
                            :itens="unidades"
                            :disabled="desabledSearchUnidade"
                            :loading="loadingSearchUnidade"
                            multiple
                            @input="getTecnicos()"
                        />

                        <form-select
                            v-model="filtroTecnicos"
                            label="Técnico responsável"
                            :itens="listtecnicos"
                            :disabled="loadingSearchTecnico"
                            :grid="6"
                            placeholder="Selecione uma unidade antes"
                            multiple
                        />

                        <form-select
                            v-model="filtroTecnicosAutor"
                            label="Técnico Autor"
                            :itens="listtecnicos"
                            :disabled="loadingSearchTecnico"
                            :grid="6"
                            placeholder="Selecione uma unidade antes"
                            multiple
                        />

                        <form-toggle
                            v-model="showfiltroIdade"
                            grid="12"
                            label="Filtrar por intervalo de idade?"
                        />

                        <div class="col-md-12 mt-3 mb-5" v-if="showfiltroIdade">
                            <label><b>Idade</b></label>
                            <vue-slider
                                v-model="filtroIdade"
                                :min="min"
                                :max="max"
                                :enable-cross="enableCross"
                                :tooltip="'always'"
                                :tooltip-placement="'bottom'"
                            />
                        </div>
                    </div>
                    <div class="row pt-4 mb-4 px-0 d-flex justify-content-end">
                        <div class="col-auto px-2 text-right">
                            <button
                                class="btn btn-default"
                                @click.prevent="
                                    limparFiltros(), (viewFilterReport = false)
                                "
                            >
                                <i class="fas fa-times"></i>
                            </button>

                            <button
                                type="button"
                                class="btn btn-secondary"
                                @click.prevent="limparFiltros()"
                            >
                                {{ $t("Limpar Filtros") }}
                            </button>

                            <button
                                class="btn btn-success btn-submit"
                                data-style="zoom-in"
                                type="submit"
                            >
                                <i class="fas fa-chart-bar"></i>
                                {{ $t("Gerar Relatório") }}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            <loading-report
                :loading="isLoadingMsg"
                mensagem="Por favor aguarde estamos realizando sua solicitação..."
                icone="fa-smile-wink"
            ></loading-report>

            <div class="col-md-12">
                <loading-animation
                    :active.sync="loading"
                    :is-full-page="false"
                    :opacity="1"
                    color="#5895FF"
                />

                <print-content>
                    <template v-slot:datas>
                        <div class="mb-4">
                            <p
                                v-if="
                                    showfiltroIdade &&
                                    filtroIdade.length === 2
                                "
                                v-html="idades"
                            ></p>

                            <div
                                class="
                                    d-flex
                                    align-items-center
                                    justify-content-between
                                "
                            >
                                <span>
                                    Período selecionado:
                                    <b>
                                        {{ datas.start }} -
                                        {{ datas.end }}
                                    </b>

                                    <b-link
                                        href="#"
                                        @click.prevent="void 0"
                                        class="mb-2"
                                        variant="info"
                                        v-b-popover.hover.top="
                                            'Através do botão filtros você pode selecionar um intervalo de datas para impressão de seus dados.'
                                        "
                                    >
                                        <i class="fas fa-info-circle"></i>
                                    </b-link>
                                </span>

                                <span v-if="pagination.total">
                                    Total de Registros
                                    <b>{{ pagination.total }}</b>,
                                    total por página
                                    <b>{{ pagination.perPage }}</b>
                                </span>
                            </div>
                        </div>
                    </template>

                    <b-table
                        :fields="[
                            {
                                key: 'protocolo',
                                label: $t('Detalhes'),
                            },
                            {
                                key: 'motivo',
                                label: $t('Motivo'),
                            },
                            {
                                key: 'cadastrado',
                                label: $t('Data'),
                            },
                            {
                                key: 'status',
                                label: $t('Status'),
                            },
                        ]"
                        :items="itensList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="xs"
                        table-class="mb-3"
                    >
                        <template v-slot:cell(protocolo)="data">
                            Usuário:
                            <strong
                                v-html="
                                    $options.filters.highlight(
                                        data.item.nome_acolhido,
                                        search
                                    )
                                "
                            >
                            </strong>
                            <b>
                                {{
                                    data.item.usuario_idade !== null &&
                                    data.item.usuario_idade !== undefined
                                        ? `- ${data.item.usuario_idade} Ano(s)`
                                        : ""
                                }}
                            </b>
                            <br />
                            Protocolo:
                            <b
                                v-html="
                                    $options.filters.highlight(
                                        data.item.protocolo,
                                        search
                                    )
                                "
                            ></b>
                            <br />
                            Técnico:
                            <b
                                v-html="
                                    $options.filters.highlight(
                                        data.item.user.name,
                                        search
                                    )
                                "
                            ></b>
                            <br />
                            Unidade:
                            <b v-if="data.item.unidade">{{
                                data.item.unidade.nome
                            }}</b>
                            <br />
                            <i
                                class="mdi mdi-lock mdi-18px text-danger"
                                v-if="data.item.privado == 1"
                                v-b-popover.hover.top="
                                    'Acolhimento com sigilo.'
                                "
                            ></i>
                        </template>
                        <template v-slot:cell(motivo)="data">
                            <ul
                                v-if="
                                    data.item.motivos_descricao &&
                                    data.item.motivos_descricao.length > 0
                                "
                                class="mb-0"
                            >
                                <li
                                    v-for="(
                                        motivo,
                                        index
                                    ) in data.item.motivos_descricao"
                                    :key="index"
                                >
                                    {{ motivo }}
                                </li>
                            </ul>
                        </template>
                        <template v-slot:cell(cadastrado)="data">
                            {{ data.item.cadastrado }}
                        </template>
                        <template v-slot:cell(status)="data">
                            <span v-html="data.item.status_nome"></span>
                        </template>
                        <template v-slot:empty="scope">
                            <div class="text-center my-5">
                                <img
                                    :alt="$t('No results')"
                                    class="mb-5"
                                    src="/img/icons/robot.svg"
                                    style="max-height: 165px"
                                />
                                <h3 class="bold">
                                    {{ $t("No records found") }}
                                </h3>
                            </div>
                        </template>
                    </b-table>
                </print-content>

                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="form-group d-inline-flex mb-0">
                            <select
                                class="form-control"
                                style="width: 70px"
                                v-model="perPage"
                                v-on:change="getAnalytics"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div class="d-inline-flex ml-2">
                            <b-pagination
                                :per-page="perPage"
                                :total-rows="pagination.total"
                                @change="changePage"
                                v-model="page"
                            />
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                        <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }} {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                        </div>
                    </div>
                </div>

                <div class="box-btn-print no-print" v-if="!loading">
                    <b-button
                        :title="$t('Visualizar e Imprimir')"
                        class="py-2"
                        size="sm"
                        type="button"
                        v-b-tooltip.hover
                        variant="primary"
                        @click="print()"
                    >
                        <i class="fas fa-print"></i>
                    </b-button>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
export default {
    name: "HomeReportAcolhimentosGeral",
    data() {
        return {
            loading: true,
            loadingSearchUnidade: true,
            desabledSearchUnidade: true,
            loadingSearchTecnico: true,
            range: null,
            itensList: [],
            unidades: [],
            tecnicos: [],
            page: 1,
            search: "",
            perPage: 10,
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0,
            },
            filtros: {
                unidade: null,
            },
            isLoadingMsg: false,
            filter: false,
            user_id: null,
            tecnico_id: null,
            unidade_id: null,
            role: null,
            loadingStatus: false,
            loadingTipos: false,
            tipos: [],
            status: [],
            datas: [],
            filtroUnidades: [],
            filtroTecnicos: [],
            filtroTecnicosAutor: [],
            filtroDatas: [],
            filtroStatus: [],
            filtroMotivo: [],
            dataNow: moment().format("YYYY/MM/DD"),
            filtroIdade: [],
            showfiltroIdade: false,
            idades: null,
            min: 0,
            max: 130,
            enableCross: false,
        };
    },
    mounted() {
        this.getStatus();
        this.getUnidades();
        this.getAnalytics();
    },
    watch: {
        showfiltroIdade(val) {
            this.filtroIdade = val ? [0, 130] : [];
        },
    },
    computed: {
        motivosAcolhimentoGeral() {
            const motivosCrianca =
                (
                    this.$root.arrays
                        .acolhimento_motivo || []
                ).map((item) => ({
                    id: `crianca:${item.id}`,
                    value:
                        `Criança/Adolescente - ${item.value}`,
                }));

            const motivosIdoso =
                (
                    this.$root.arrays
                        .acolhimento_motivo_idoso || []
                ).map((item) => ({
                    id: `idoso:${item.id}`,
                    value:
                        `Pessoa idosa - ${item.value}`,
                }));

            return [
                ...motivosCrianca,
                ...motivosIdoso,
            ];
        },
        listtecnicos() {
            const pessoas = this.tecnicos;

            const map = pessoas.map((elem) => ({
                id: elem.id,
                value: " <b>" + elem.value + "</b> - " + elem.nome_unidade,
            }));
            return map;
        },
    },
    methods: {
        prepararFiltros() {
            this.filtroDatas = [];

            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(
                        this.data_inicio
                    )
                );
            }

            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(
                        this.data_fim
                    )
                );
            }

            if (
                this.showfiltroIdade &&
                this.filtroIdade.length === 2
            ) {
                this.idades =
                    "Usuários com idade entre: " +
                    this.filtroIdade[0] +
                    " ano(s) e " +
                    this.filtroIdade[1] +
                    " ano(s)";
            } else {
                this.idades = null;
            }
        },
        filterData(value) {
            return this.$options.filters.formatDateHora(value);
        },
        updateAnalytics(range) {
            if (this.range !== range) {
                this.range = range;
                this.getAnalytics();
            }
        },
        changePage(page) {
            if (
                page > 0 &&
                page <= this.pagination.totalPages &&
                page !== this.page
            ) {
                this.page = page;
                this.getAnalytics();
            }
        },
        getAnalytics() {

            this.prepararFiltros();

            this.isLoadingMsg = true;
            this.loading = true;

            this.filtroDatas = [];
            if (this.data_inicio) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_inicio)
                );
            }
            if (this.data_fim) {
                this.filtroDatas.push(
                    this.$options.filters.formatDateYMD(this.data_fim)
                );
            }

            if (this.filtroIdade && this.filtroIdade.length > 0) {
                this.idades =
                    "Usuários com Idade entre: " +
                    this.filtroIdade[0] +
                    " ano(s) e " +
                    this.filtroIdade[1] +
                    " ano(s)";
            }

            axios
                .get("api/dashboard/report/acolhimentos/geral/home", {
                    params: {
                        page: this.page,
                        filtroSearch: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroUnidades: this.filtroUnidades,
                        filtroTecnicos: this.filtroTecnicos,
                        filtroTecnicosAutor: this.filtroTecnicosAutor,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                        filtroIdade: this.filtroIdade,
                        filtroMotivo: this.filtroMotivo,
                    },
                })
                .then((response) => {
                    this.loading = false;

                    this.user_id = this.$store.state.user.id;
                    this.tecnico_id = this.$store.state.user.tecnico.id;
                    this.unidade_id = this.$store.state.unidade;
                    this.role = this.$store.state.user.role;

                    this.datas = response.data.datas;
                    this.itensList = response.data.dados.original.data;
                    this.pagination = response.data.dados.original.pagination;
                    if (
                        this.pagination.totalPages < this.pagination.currentPage
                    ) {
                        this.page = this.pagination.totalPages;
                        this.getAnalytics();
                    } else {
                        this.isLoadingMsg = false;
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        getUnidades() {
            this.loadingSearchUnidade = true;
            this.desabledSearchUnidade = true;
            axios
                .get(`api/dashboard/unidades/get/externas`)
                .then((response) => {
                    this.unidades = response.data;
                })
                .finally(() => {
                    this.loadingSearchUnidade = false;
                    this.desabledSearchUnidade = false;
                });
        },
        getStatus() {
            this.loadingStatus = true;
            axios
                .get(`api/dashboard/status/acolhimento`)
                .then((response) => {
                    this.status = response.data;
                })
                .finally(() => {
                    this.loadingStatus = false;
                });
        },
        getTecnicos() {
            this.tecnicos = [];
            this.loadingSearchTecnico = true;
            axios
                .get(`api/dashboard/atendimento/tecnicos/get`, {
                    params: {
                        unidades: this.filtroUnidades,
                    },
                })
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => (this.loadingSearchTecnico = false));
        },
        exportar() {
            this.prepararFiltros();

            this.isLoadingMsg = true;
            this.loading = true;
            swal.fire({
                title: "Aguarde! O Arquivo está sendo gerado.",
                text: "O tempo para finalizar pode demorar dependendo da quantidade de registros.",
                imageUrl: `${window.urlbase}img/load.gif`,
                showConfirmButton: false,
            });
            axios
                .get("api/dashboard/report/acolhimentos/geral/home", {
                    params: {
                        page: this.page,
                        filtroSearch: this.search,
                        perPage: this.perPage,
                        range: this.range,
                        filtroUnidades: this.filtroUnidades,
                        filtroTecnicos: this.filtroTecnicos,
                        filtroTecnicosAutor: this.filtroTecnicosAutor,
                        filtroStatus: this.filtroStatus,
                        filtroDatas: this.filtroDatas,
                        filtroIdade: this.filtroIdade,
                        filtroMotivo: this.filtroMotivo,
                        export: "ok",
                    },
                })
                .then((response) => {
                    swal.fire({
                        title: "Arquivo pronto para download!",
                        html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
                        icon: "success",
                        showConfirmButton: false,
                    });
                })
                .finally(() => {
                    this.isLoadingMsg = false;
                    this.loading = false;
                });
        },
        limparFiltros() {
            //   this.filtros = {};
            this.search = "";
            this.data_inicio = null;
            this.data_fim = null;
            this.filtros.data_inicial = null;
            this.filtros.data_final = null;

            this.filtroUnidades = [];
            this.filtroTecnicos = [];
            this.filtroTecnicosAutor = [];
            this.filtroDatas = [];
            this.filtroStatus = [];
            this.filtroMotivo = [];

            this.filtroIdade = [];
            this.showfiltroIdade = false;
            this.idades = null;

            this.range = null;

            this.getAnalytics();
        },
    },
};
</script>
